// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ad09865","453":"cf17b459","455":"9e739cf4","977":"139d5620"}[chunkId] + ".chunk.js";
};